import { faBuilding, faChartLine, faFileInvoiceDollar, faHandshake, faReceipt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { formatCurrencyToLocale, formatValueToLocale } from "../../../../utils/method";
import "./PlanningSummaryCards.scss";

function PlanningSummaryCards({ summary }) {
    const { t } = useTranslation();

    const statusPct = Math.min(summary?.projectStatusPercentage || 0, 100);

    return (
        <div className="kpi-cards-strip">

            <div className="kpi-card kpi-card--cost">
                <div className="kpi-card__icon">
                    <FontAwesomeIcon icon={faFileInvoiceDollar} />
                </div>
                <div className="kpi-card__body">
                    <div className="kpi-card__label">{t("planning.cost-calculation")}</div>
                    <div className="kpi-card__value">
                        {formatCurrencyToLocale(summary?.totalForecastedBudget || 0)}
                    </div>
                </div>
            </div>

            <div className="kpi-card kpi-card--companies">
                <div className="kpi-card__icon">
                    <FontAwesomeIcon icon={faBuilding} />
                </div>
                <div className="kpi-card__body">
                    <div className="kpi-card__label">{t("planning.contracted-companies")}</div>
                    <div className="kpi-card__value">{summary?.contractedCompaniesCount || 0}</div>
                </div>
            </div>

            <div className="kpi-card kpi-card--invoices">
                <div className="kpi-card__icon">
                    <FontAwesomeIcon icon={faReceipt} />
                </div>
                <div className="kpi-card__body">
                    <div className="kpi-card__label">{t("planning.invoices")}</div>
                    <div className="kpi-card__value">
                        {(summary?.invoiceDraftCount || 0) + (summary?.invoiceFinalizedCount || 0)}
                    </div>
                    <div className="kpi-card__sub">
                        {summary?.invoiceDraftCount || 0} {t("planning.invoices-draft")} · {summary?.invoiceFinalizedCount || 0} {t("planning.invoices-finalized")}
                    </div>
                </div>
            </div>

            <div className="kpi-card kpi-card--supplements">
                <div className="kpi-card__icon">
                    <FontAwesomeIcon icon={faHandshake} />
                </div>
                <div className="kpi-card__body">
                    <div className="kpi-card__label">{t("planning.supplements")}</div>
                    <div className="kpi-card__value">
                        {(summary?.supplementsApprovedCount || 0) + (summary?.supplementsOpenCount || 0)}
                    </div>
                    <div className="kpi-card__sub">
                        {summary?.supplementsApprovedCount || 0} {t("planning.supplements-approved")} · {summary?.supplementsOpenCount || 0} {t("planning.supplements-open")}
                    </div>
                </div>
            </div>

            <div className="kpi-card kpi-card--status">
                <div className="kpi-card__icon">
                    <FontAwesomeIcon icon={faChartLine} />
                </div>
                <div className="kpi-card__body">
                    <div className="kpi-card__label">{t("planning.project-status")}</div>
                    <div className="kpi-card__value">{formatValueToLocale(statusPct)}%</div>
                    <div className="kpi-card__progress">
                        <div className="kpi-card__progress-fill" style={{ width: `${statusPct}%` }} />
                    </div>
                </div>
            </div>

        </div>
    );
}

export default PlanningSummaryCards;
